import type { RequestPayload } from "@inertiajs/core";
import { usePage } from "@inertiajs/react";
import { Checkbox, Divider, Fieldset, Stack, TextInput } from "@mantine/core";
import { useForm } from "@mantine/form";
import type { School } from "../../models/school";
import { SaveButton } from "../button/SaveButton";

type SchoolFormProps = {
  school?: School;
  submitButtonLabel: string;
  onSubmit: (values: RequestPayload) => void;
};

type FormErrors = {
  bms?: string[];
  title?: string[];
  short?: string[];
};

export function SchoolForm({ school, submitButtonLabel, onSubmit }: SchoolFormProps) {
  const { errors } = usePage<{ errors: FormErrors }>().props;

  const form = useForm({
    initialValues: {
      bms: school?.bms ?? false,
      title: school?.title,
      short: school?.short,
    },
  });

  return (
    <form onSubmit={form.onSubmit(onSubmit)}>
      <Fieldset legend="Details">
        <Stack maw="60rem">
          <TextInput withAsterisk label="Schule" key={form.key("title")} {...form.getInputProps("title")} error={errors?.title} />
          <TextInput withAsterisk label="Kürzel" key={form.key("short")} {...form.getInputProps("short")} error={errors?.short} />
          <Checkbox label="BMS" key={form.key("bms")} {...form.getInputProps("bms", { type: "checkbox" })} error={errors?.bms} />
          <Divider />
          <SaveButton label={submitButtonLabel} />
        </Stack>
      </Fieldset>
    </form>
  );
}
